import ClienteService from "services/cliente";
import {
  Stack,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Box,
  TextField,
  InputAdornment,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, useContext, useEffect, useRef } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CondominioService from "services/condominio";
import ApiContext from "api";
import { useLocation } from "react-router-dom";
import { ImgWave } from "../../Icons/ImgWave";
import { cloneElement } from "react";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import ListSubheader from "@mui/material/ListSubheader";

export default function NavBar({ tabs, onToggleSidebar, sidebarOpen }) {
  const getAddressKey = (addr) =>
    `${addr["cod-condominio"]}-${addr["local-entrega"]}`;

  const [selectedValue, setSelectedValue] = useState(
    CondominioService.selectAll
      ? "all"
      : getAddressKey(CondominioService.selected)
  );
  const location = useLocation();
  const currentPath = location.pathname;

  const { ConsigazApi } = useContext(ApiContext);

  const [addressSearch, setAddressSearch] = useState("");
  const addressSearchInputRef = useRef(null);

  useEffect(() => {
    addressSearchInputRef.current?.focus();
  }, [addressSearch]);

  const {
    segmento,
    [`nome-emit`]: name,
    ClienteEntrRetorno: addressList,
  } = ClienteService.localEntrega || {};

  const nameContato = ClienteService?.industrialContato?.name;

  const addressOptions = [
    ...(segmento === "INDUSTRIAL" || segmento === "LICITACAO"
      ? [{ title: "Todos os endereços", value: "all" }]
      : []),
    ...(addressList || []).map((address) => ({
      title: address["endereco"],
      value: getAddressKey(address),
    })),
  ];

  const filteredAddressOptions = addressOptions.filter((option) =>
    option.title.toLowerCase().includes(addressSearch.toLowerCase())
  );

  const handleAddressChange = (e) => {
    const { ClienteEntrRetorno: addressList } =
      ClienteService.localEntrega || {};
    const cod = e.target.value;

    setSelectedValue(cod);

    if (cod === "all") {
      CondominioService.selectAll = true;
      ConsigazApi.clearMemoize();
      window.location.reload();
    } else {
      const filter = addressList.filter((addr) => getAddressKey(addr) === cod);

      if (filter.length) {
        CondominioService.selected = filter[0];
        ConsigazApi.clearMemoize();
        window.location.reload();
      }
    }
  };

  return (
    <Stack
      width={"100%"}
      bgcolor={"#053462"}
      zIndex={950}
      position="fixed"
      height={"115px"}
      justifyContent={"center"}
      sx={{
        boxShadow: "0px 4px 4px 0px #00000026;",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "-28px",
          left: 0,
          width: "100%",
          height: "146px",
          overflow: "hidden",
          zIndex: -1,
        }}
      >
        <ImgWave />
      </Box>
      <Stack
        justifyContent={"space-evenly"}
        direction={"row"}
        alignItems={"center"}
        zIndex={1}
      >
        <Stack>
          <Stack
            direction={"row"}
            gap={"12px"}
            mb={"10px"}
            alignItems={"center"}
          >
            <Stack
              borderRadius={"8px"}
              padding={"5px"}
              bgcolor={"#FFFFFFCC"}
              sx={{
                cursor: "pointer",
              }}
              onClick={onToggleSidebar}
            >
              {!sidebarOpen ? (
                <MenuIcon sx={{ color: "#053462", fontSize: "20px" }} />
              ) : (
                <CloseIcon sx={{ color: "#053462", fontSize: "20px" }} />
              )}
            </Stack>

            <Typography fontSize={"18px"} fontWeight={700} color={"#FFFFFF"}>
              Olá, {(nameContato ?? name ?? "").split(" ")[0]}
            </Typography>
          </Stack>
          <FormControl variant="outlined" sx={{ width: "366px" }}>
            <Select
              value={selectedValue}
              onChange={handleAddressChange}
              onClose={() => setAddressSearch("")}
              IconComponent={KeyboardArrowDownIcon}
              MenuProps={{
                PaperProps: { sx: { maxHeight: "320px" } },
                MenuListProps: { sx: { paddingTop: 0, paddingBottom: "4px" } },
              }}
              sx={{
                backgroundColor: "#FFFFFFCC",
                borderRadius: 2,
                fontSize: "11px",
                color: "#053462",
                fontWeight: 500,
                textAlign: "left",
                height: "28px",
              }}
            >
              <ListSubheader
                sx={{
                  lineHeight: "normal",
                  padding: "8px 8px 4px",
                }}
              >
                <TextField
                  size="small"
                  autoFocus
                  placeholder="Buscar endereço"
                  fullWidth
                  value={addressSearch}
                  onChange={(e) => setAddressSearch(e.target.value)}
                  onKeyDown={(e) => e.stopPropagation()}
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start" sx={{ ml: "16px" }}>
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                      sx: {
                        fontSize: "12px",
                        "& input": { padding: "6px 4px" },
                      },
                    },
                    htmlInput: {
                      style: { textAlign: "left" },
                      ref: addressSearchInputRef,
                    },
                  }}
                />
              </ListSubheader>
              {filteredAddressOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  sx={{
                    fontSize: "11px",
                    color: "#053462",
                    fontWeight: 500,
                    textAlign: "left",
                    minHeight: "unset",
                    padding: "6px 12px",
                  }}
                >
                  {option.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
        <Stack direction={"row"} gap={"8px"}>
          {tabs.map((tab, i) => (
            <Stack
              key={i}
              direction={"row"}
              onClick={tab.onClick}
              gap={"4px"}
              alignItems={"center"}
              justifyContent={"center"}
              sx={{
                cursor: currentPath === tab.path ? "default" : "pointer",
              }}
              borderRadius={"8px"}
              p={"8px"}
              border={currentPath === tab.path ? "1px solid #05346299" : ""}
              backgroundColor={currentPath === tab.path ? "#FFFFFFCC" : ""}
            >
              {tab.icon &&
                cloneElement(tab.icon, {
                  style: {
                    color: currentPath === tab.path ? "#053462" : "#FFFFFF",
                  },
                })}
              <Typography
                color={currentPath === tab.path ? "#053462" : "#FFFFFF"}
                fontSize={"13px"}
                fontWeight={currentPath === tab.path ? 800 : 600}
              >
                {tab.label}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
